export const AUTH_SERVICE_UNAVAILABLE_MESSAGE =
  'Authentication service is temporarily unavailable. Please try again.';

export function isSupabaseTransportError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const candidate = error as {
    name?: unknown;
    message?: unknown;
    status?: unknown;
    code?: unknown;
    cause?: unknown;
    originalError?: unknown;
  };

  const name = typeof candidate.name === 'string' ? candidate.name.toLowerCase() : '';
  const message = typeof candidate.message === 'string' ? candidate.message.toLowerCase() : '';
  const status = typeof candidate.status === 'number' ? candidate.status : null;
  const code = typeof candidate.code === 'string' ? candidate.code.toLowerCase() : '';

  if (
    name.includes('authretryablefetcherror') ||
    name.includes('fetcherror') ||
    code.includes('fetch') ||
    message.includes('fetch failed') ||
    message.includes('failed to fetch') ||
    message.includes('network request failed') ||
    message.includes('network error') ||
    message.includes('load failed') ||
    message.includes('typeerror: fetch') ||
    status === 0 ||
    (message.length === 0 && name.includes('auth'))
  ) {
    return true;
  }

  return (
    isSupabaseTransportError(candidate.cause) ||
    isSupabaseTransportError(candidate.originalError)
  );
}

export function isExpectedAnonymousAuthError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const candidate = error as {
    name?: unknown;
    message?: unknown;
    status?: unknown;
    __isAuthError?: unknown;
    cause?: unknown;
    originalError?: unknown;
  };

  const name = typeof candidate.name === 'string' ? candidate.name.toLowerCase() : '';
  const message = typeof candidate.message === 'string' ? candidate.message.toLowerCase() : '';
  const status = typeof candidate.status === 'number' ? candidate.status : null;

  if (
    name.includes('authsessionmissingerror') ||
    message.includes('auth session missing') ||
    (candidate.__isAuthError === true && status === 400 && message.includes('session missing'))
  ) {
    return true;
  }

  return (
    isExpectedAnonymousAuthError(candidate.cause) ||
    isExpectedAnonymousAuthError(candidate.originalError)
  );
}

export function getPublicAuthErrorMessage(error: unknown, fallbackMessage: string): string {
  return isSupabaseTransportError(error) ? AUTH_SERVICE_UNAVAILABLE_MESSAGE : fallbackMessage;
}

export function shouldRenderSupabaseSessionListenerForPath(pathname: string | null | undefined): boolean {
  if (!pathname) {
    return false;
  }

  return (
    pathname === '/' ||
    pathname === '/auth/update-password' ||
    pathname.startsWith('/protected')
  );
}
